import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { noteCurrentRoute } from "./intended-route";

/**
 * Call it from `RouteMemory` and nowhere else: `noteCurrentRoute` spends the post-login intent, so
 * where this runs decides whether the intent survives the login. `RouteMemory` carries the placement
 * rules; `post-login-landing.unit.tsx` holds them to it.
 */
export const useNoteCurrentRoute = (): void => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    noteCurrentRoute(`${pathname}${search}`);
  }, [pathname, search]);
};
